import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { WorkforceService } from 'src/app/services/workforce.service';
import { createId, jsonCopyObject } from 'globals/helpers/helpers';
import { openConfirmDeleteGetResult } from 'src/app/components/dialog.confirmDelete.component';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { IconComponent } from 'src/app/components/icon/icon.component';

@Component({
    selector: 'upsert-group-dialog',
    template: `
  <div class="upsert-group-dialog joi-dialog">
      <div mat-dialog-title>{{is_new ? 'New' : 'Edit'}} Group</div>
      <div mat-dialog-content>
          <div class="label" *ngIf="is_new">Give your group a name:</div>
          <mat-form-field class="general">
              <input matInput id="name" name="name" [(ngModel)]="group_name" placeholder="Group name">
          </mat-form-field>
      </div>
      <div mat-dialog-actions>
          <button mat-button class="delete" *ngIf="!is_new" (click)="deleteGroup($event)"><icon icon="delete_24px"></icon></button>
          <div style="flex:1;"></div>
          <button mat-button  (click)="dialogRef.close()">CANCEL</button>
          <button mat-button color="primary" (click)="saveGroup()" tabindex="1" [disabled]="!group_name">{{is_new ? 'Create group' : 'Save'}}</button>
      </div>
  </div>
  `,
    styleUrls: [`./workforce.main.scss`],
    standalone: true,
    imports: [MatDialogModule, MatButtonModule, FormsModule,IconComponent, CommonModule, MatFormFieldModule, MatInputModule],
})
export class UpsertGroupDialogComponent {
  is_new = true;
  group_name = '';
  constructor(public dialogRef: MatDialogRef<UpsertGroupDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
      public workforce: WorkforceService, private dialog: MatDialog) {
      this.data = jsonCopyObject(this.data)
      this.is_new = data.is_new;
      if (!this.is_new) {
          this.group_name = data.group.realName;
      }
  }

  async deleteGroup(evt) {
    const rect = evt.target.getBoundingClientRect();

    const data = { rect, title: 'Delete this group', dialog: this.dialog }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return

    this.workforce.deleteGroup(this.data.idx)
    this.dialogRef.close({ cmd: 'delete' })

  }
  saveGroup() {
      if (this.is_new) {
        this.workforce.addGroup({ realName: this.group_name, name: createId(), members: [] })
      } else {
          this.data.group.realName = this.group_name;
          this.workforce.modifyGroup(this.data.idx, this.data.group);
      }
      this.dialogRef.close();
  }

}
